import React from 'react'
import styled from 'styled-components';
import {colours} from '../Styles';
import {icons} from '../img/Icons';

function WhyChooseItem(props) {
    const {dark, accent} = colours;
    const {check} = icons;
    const WhyChooseItem = styled.div`
        color: ${dark};
        font-size: 20px;
        font-family: Montserrat, sans-serif;
        display: flex;
        align-items: center;
        min-width: 50%;
        svg {
            margin-right: 20px;
            fill: ${accent};
        }  
    `;
    return (
        <WhyChooseItem>
            {check}
            {props.text}
        </WhyChooseItem>
    )
}

export default WhyChooseItem;